import {
  ACTION_EVENT,
  ACTION_MESSAGE,
  DASHBOARD_ACCESS
} from "@/modules/Dashboards/AdminDashboard/constants/ActionConstants";
import { ActionParameters } from "@/modules/Dashboards/AdminDashboard/models/ActionParameters";
import { DashboardService } from "@/modules/Dashboards/AdminDashboard/services/DashboardService";
import {
  EVENT_MESSAGES,
  LABEL
} from "@/modules/Events/constants/EventConstants";
import {
  INFO_GROUPS_ACCESS,
  INFO_GROUP_CONSTANTS
} from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { InfoGroupService } from "@/modules/InfoGroup/services/InfoGroupService";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";
import { ListService } from "@/modules/List/services/ListService";
import NotificationModal from "@/modules/Notification/components/NotificationModal/NotificationModal.vue";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import { NotificationParams } from "@/modules/Notification/models/NotificationParams";
import { USER_TEMP_CONSTANTS } from "@/modules/UserTemplate/constants/UserTemplateConstants";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { ID_FILTER } from "@/shared/components/GenericSearchBar/constants/GenericSearchConstants";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { ObjFilterList } from "@/shared/components/GenericSearchBar/model/List";
import ScrollBottom from "@/shared/components/ScrollBottom/ScrollBottom.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES, LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import { ListCategory } from "@/shared/models/ListCategory";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  DOCLIST_ID,
  DOCUMENT,
  DOCUMENTS_ACCESS,
  DOCUMENT_FILTERS,
  DOCUMENT_FORM_FILTERS
} from "../../constants/DocumentConstants";
import { DocumentBasicData } from "../../models/DocumentBasicData";
import { DocumentDTO } from "../../models/DocumentDTO";
import { DocumentQueryDTO } from "../../models/DocumentQueryDTO";
import { DocumentService } from "../../services/DocumentService";
import DocumentCard from "../DocumentCard/DocumentCard.vue";
import { NAME_FINDERS } from "@/shared/constants/GeneralConstants";
import { GO_TO_TOP } from "@/modules/Home/constants/HomeConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Option } from "@/modules/List/models/Option";
import { List } from "@/modules/List/models/List";
import { ListQuery } from "@/modules/List/models/ListQuery";
import { LIST_QUERY } from "@/modules/Profile/constants/ProfileConstants";
import AddFileModal from "@/modules/Profile/components/AddFileModal/AddFileModal.vue";
import { FILE } from "@/shared/constants/FileConstants";
import { Utils } from "@/shared/utils/utils";
import firebase from "firebase/app";
import "firebase/storage";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import lodash from "lodash";
import { ActionId } from "@/modules/Dashboards/AdminDashboard/models/ActionId";
import { DEFAULT_RECIPIENTS_KEYS } from "@/shared/components/MessageRecipients/constants/RecipientsConstants";

Vue.use(Vuetify);
@Component({
  name: "ListDocuments",
  components: {
    ScrollBottom,
    DocumentCard,
    GenericSearchBar,
    DocumentViewer,
    EmptyState,
    NotificationModal,
    AddFileModal,
    ModalTemplate
  }
})
export default class ListDocuments extends Vue {
  @Prop({ default: "" }) private userId!: string;

  @Inject() documentService!: DocumentService;
  @Inject() listService!: ListService;
  @Inject() dashboardService!: DashboardService;
  @Inject() infoGroupService!: InfoGroupService;

  SWITCH_NAME = LABEL.SWITCH;

  documentDialog = false;
  notificationDialog = false;
  lastRef = "";
  canSearch = false;
  loadingData = false;
  defaultDocument: DocumentDTO = {} as DocumentDTO;
  documentDataList: DocumentDTO[] = [];
  documentQuery: DocumentQueryDTO = {} as DocumentQueryDTO;
  documentName = "";
  documentURL = "";
  categoryData: ListCategory[] = [];
  notifications: NotificationConfig[] = [];
  categories: {
    key: string;
    name: string;
  }[] = [];
  subCategories: {
    key: string;
    name: string;
  }[] = [];
  userInfoParams: NotificationParams[] = [];
  filterArray = DOCUMENT_FILTERS;
  filterArraySearch = DOCUMENT_FORM_FILTERS;
  EMPTY_STATE_HEADER = DOCUMENT.LIST_EMPTY_STATE.HEADER;
  EMPTY_STATE_PARAGRAPH = DOCUMENT.LIST_EMPTY_STATE.PARAGRAPH;
  SEARCH_LIST_DOCUMENT_KEY = NAME_FINDERS.LIST_DOCUMENT;

  DOCLIST_ID = DOCLIST_ID;
  GO_TO_TOP_BTN = GO_TO_TOP;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  showGoTopBtn = false;
  documentToEdit: DocumentDTO = new DocumentDTO();
  showEditDocumentModal = false;
  listDocumentCategories: List[] = [];
  dataFilter: DocumentQueryDTO = new DocumentQueryDTO();
  confirmDeletDialog = false;
  confirmationText = "";
  confirmationTitle = "";

  async mounted() {
    await this.loadDocuments();
    await this.loadCategories();
    await this.loadInfoGroupFieldsByName();
    this.fillCategoriesFilter();
    this.fillSubCategoriesFilter();
  }

  async searchData(data: DocumentQueryDTO) {
    this.dataFilter = data;
    const filter: DocumentQueryDTO = { userId: this.userId };
    if (data.dateEnd) {
      filter.dateEnd = data.dateEnd;
    }
    if (data.dateStart) {
      filter.dateStart = data.dateStart;
    }
    if (data.name && data.name.length) {
      filter.name = data.name[0];
    }
    if (data.category && data.category.length) {
      filter.category = data.category[0];
    }
    if (data.subCategory && data.subCategory.length) {
      filter.subCategory = data.subCategory[0];
    }

    this.searchWithFilter(filter);
  }

  async handleSearchBarInfo(
    data: { type: string; key: string },
    category?: ObjFilterList[]
  ) {
    const listCategory =
      category && category.length
        ? this.categoryData.find(x => x.name == category[0].key)
            ?.subcategories ?? []
        : this.categoryData.flatMap(x => x.subcategories);

    this.updateSubCategory(listCategory);
  }

  async searchWithFilter(filter: DocumentQueryDTO) {
    this.documentDataList = [];
    this.lastRef = "";
    this.canSearch = true;

    await this.loadDocuments(filter);
  }

  async loadDocuments(filter?: DocumentQueryDTO) {
    this.canSearch = true;
    try {
      this.loadingData = true;

      this.documentQuery = {
        userId: this.userId
      };
      Object.assign(this.documentQuery, filter);

      if (this.lastRef !== "") {
        this.documentQuery.lastRef = this.lastRef;
      }

      const documentDataResponse = await this.documentService.getDocumentByFilter(
        this.documentQuery
      );

      if (
        documentDataResponse.code === Http.Found &&
        documentDataResponse.data
      ) {
        if (documentDataResponse.data.lastReference !== this.lastRef) {
          this.documentDataList = this.documentDataList.concat(
            documentDataResponse.data.documentArray
          );
          this.lastRef = documentDataResponse.data.lastReference;
        } else {
          this.canSearch = false;
        }
      } else if (documentDataResponse.code === Http.NotFound) {
        Snackbar.popInfo(DOCUMENT.MESSAGE.NO_MORE_DATA);
      } else {
        Snackbar.popError(documentDataResponse.message);
        this.canSearch = false;
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DOCUMENTS_ACCESS.GET
        );
      else Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
    }
    this.loadingData = false;
  }

  async loadCategories() {
    try {
      const filterQuery: ListQuery = {};
      filterQuery.isCategoryList = [LIST_QUERY.ACTIVO];
      filterQuery.listType = [LIST_QUERY.PACIENTE];
      filterQuery.isDocumentCategoryList = [LIST_QUERY.ACTIVO];

      const categoriesListRespose = await this.listService.getChart(
        filterQuery
      );
      if (
        categoriesListRespose.code === Http.Found &&
        categoriesListRespose.data
      ) {
        this.listDocumentCategories = categoriesListRespose.data
          .listArray as List[];

        this.categoryData = categoriesListRespose.data.listArray.map(
          (item: List) => {
            return {
              idReference: item.id as string,
              name: item.name as string,
              subcategories: item.options.map((option: Option) => option.value)
            };
          }
        );

        this.getCategories();
      } else {
        Snackbar.popError(categoriesListRespose.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(EVENT_MESSAGES.REQUEST_FAILED);
    }
  }

  async loadInfoGroupFieldsByName() {
    try {
      const responseData = await this.infoGroupService.getInfoGroupFieldByName(
        INFO_GROUP_CONSTANTS.INFO_GROUP_BASIC_NAME
      );
      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.userInfoParams = responseData.data;
      } else {
        Snackbar.popInfo(USER_TEMP_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_GROUPS);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  updateCategory() {
    const category = this.filterArraySearch[0].secondaryFilters.find(
      filter => filter.key == ID_FILTER.CATEGORY
    );
    category!.options = this.categoryData.map(category => ({
      key: category.name,
      name: category.name
    }));
  }

  updateSubCategory(subCategoryList: string[]) {
    const subCategory = this.filterArraySearch[0].secondaryFilters.find(
      filter => filter.key == ID_FILTER.SUB_CATEGORY
    );
    subCategory!.options = subCategoryList.map(category => ({
      key: category,
      name: category,
      selected: false
    }));
    subCategory!.reload = 1 - (subCategory!.reload ?? 0);
  }

  getCategories() {
    this.updateCategory();
    let subCategoryList: string[] = [];
    this.categories = [];
    this.categoryData.forEach(category => {
      const object = {
        key: category.name,
        name: category.name
      };
      this.categories.push(object);
      subCategoryList = subCategoryList.concat(category.subcategories);
    });

    this.getSubCategories(subCategoryList);
  }

  getSubCategories(subCategoryList: string[]) {
    this.updateSubCategory(subCategoryList);
    this.subCategories = [];
    subCategoryList.forEach(subCategory => {
      const object = {
        key: subCategory,
        name: subCategory
      };
      this.subCategories.push(object);
    });
  }

  fillCategoriesFilter() {
    const index = this.filterArray.findIndex(
      filter => filter.key === "category"
    );
    if (index !== -1) this.filterArray[index].options = this.categories;
  }

  fillSubCategoriesFilter() {
    const index = this.filterArray.findIndex(
      filter => filter.key === "subCategory"
    );
    if (index !== -1) this.filterArray[index].options = this.subCategories;
  }

  async onBottom() {
    if (this.canSearch && !this.loadingData)
      await this.loadDocuments(this.documentQuery);
  }

  async showDocument(documentBasicData: DocumentBasicData) {
    if (documentBasicData.downloadOnly) {
      this.documentURL = documentBasicData.documentURL;
      return;
    }

    this.documentDialog = true;
    this.documentURL = documentBasicData.documentURL;
    this.documentName = documentBasicData.documentName;
  }

  editDocument(index: number) {
    this.documentToEdit = this.documentDataList[index];
    this.showEditDocumentModal = true;
  }

  deleteDocument() {
    this.confirmationTitle = DOCUMENT.MESSAGE.DELETE_DIALOG_TITLE;
    this.confirmationText = DOCUMENT.MESSAGE.DELETE_DIALOG_TEXT;
    this.confirmDeletDialog = true;
  }

  async uploadDocument(
    docId: string,
    category: ListCategory,
    subCategory: string
  ) {
    try {
      this.showEditDocumentModal = false;
      const categoryFound = this.listDocumentCategories.find(
        item => item.id === category.idReference
      );

      const documentDataResponse = await this.documentService.updateDocument({
        documentId: docId,
        categoryId: category.idReference,
        subCategoryId: categoryFound?.options.find(
          option => option.title === subCategory
        )?.id
      });

      if (documentDataResponse.code === Http.Ok) {
        Snackbar.popSuccess(documentDataResponse.message);
        this.searchData(this.dataFilter);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + INFO_GROUPS_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  closePreview() {
    this.documentDialog = false;
  }

  async openNotificationDialog(index: number) {
    this.defaultDocument = lodash.cloneDeep(this.documentDataList[index]);
    if (!this.defaultDocument.migrate) {
      const url = await Utils.shortUrl(
        this.documentService,
        this.defaultDocument,
        this.userId
      );
      this.defaultDocument.documentPath = url as string;
      this.notificationDialog = true;
      return;
    }

    const urls = await Utils.signUrl(
      this.documentService,
      this.defaultDocument,
      this.userId
    );

    if (urls) {
      this.defaultDocument.documentPath = urls.shortUrl;
      this.defaultDocument.documentPathSigned = urls.signedUrl;
      this.notificationDialog = true;
      return;
    }
    Snackbar.popError(DOCUMENT.MESSAGE.ERROR_TO_GET_URL);
  }

  updateSubcategory(categoryKey: string) {
    const index = this.categoryData.findIndex(
      category => category.name === categoryKey
    );
    if (index !== -1) {
      this.getSubCategories(this.categoryData[index].subcategories);
      this.fillSubCategoriesFilter();
    }
  }

  resetSubcategories() {
    let subCategoryList: string[] = [];
    this.categoryData.forEach(category => {
      subCategoryList = subCategoryList.concat(category.subcategories);
    });
    this.getSubCategories(subCategoryList);
    this.fillSubCategoriesFilter();
  }

  enableFilter(index: number) {
    this.filterArray[index].disabled = false;
  }

  disableFilter(key: string) {
    this.filterArray.forEach(item => {
      if (item.key === key) {
        item.disabled = true;
      }
    });
  }

  enableAllFilters() {
    this.filterArray.forEach(filter => (filter.disabled = false));
  }

  handleCloseNotification() {
    this.notificationDialog = false;
  }

  async sendAction(newAction: ActionParameters) {
    try {
      const responseData = await this.dashboardService.applyUserActions(
        newAction
      );

      if (
        responseData.code === Http.Ok ||
        responseData.code === Http.PartialContent
      ) {
        Snackbar.popSuccess(responseData.message);
        this.notificationDialog = false;
      } else {
        Snackbar.popInfo(ACTION_MESSAGE.FAILED);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async acceptNotification(notification: NotificationConfig) {
    const multipleRecipients: ActionId[] = [];
    notification.recipients.dependencyUsers.forEach((user: any) => {
      if (user) {
        const userCustom = { id: user.id, ref: user.id };
        multipleRecipients.push(userCustom);
      }
    });
    notification.recipients.defaultRecipients.forEach((recipient: any) => {
      if (recipient) {
        if (
          recipient == DEFAULT_RECIPIENTS_KEYS.USER ||
          recipient.param == DEFAULT_RECIPIENTS_KEYS.USER
        ) {
          multipleRecipients.push({ id: this.userId, ref: this.userId });
        } else if (
          [
            DEFAULT_RECIPIENTS_KEYS.CHANGED_BY,
            DEFAULT_RECIPIENTS_KEYS.CREATED_BY
          ].includes(recipient.param)
        ) {
          const user = localStorage.getItem(LOCAL_STORAGE.UID) || "";
          multipleRecipients.push({ id: user, ref: user });
        }
      }
    });
    const action: ActionParameters = {
      ids: [{ id: this.userId }],
      type: ACTION_EVENT.NOTIFICATION,
      notifications: [notification]
    };
    if (multipleRecipients.length > 0) {
      const recipients = Array.from(
        new Map(multipleRecipients.map(item => [item.id, item])).values()
      );
      action.ids = recipients;
    }

    this.notificationDialog = false;
    await this.sendAction(action);
  }

  cancelNotification() {
    this.notificationDialog = false;
  }
  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    if (target.scrollTop + target.clientHeight + 5 >= target.scrollHeight) {
      this.onBottom();
    }
    this.showGoTopBtn = target.scrollTop >= 100;
  }

  goToTop() {
    const target = document.getElementById(this.DOCLIST_ID);
    if (target) {
      target.scrollTop = 0;
      this.showGoTopBtn = false;
    }
  }

  closeEditDocumentModal() {
    this.showEditDocumentModal = false;
  }

  async deleteFileFromStorage(document: DocumentDTO) {
    try {
      const fileRef = firebase
        .storage()
        .ref(
          `${Utils.getClientStoragePath()}/${FILE.FILE_STORAGE_FOLDER}/${
            document.userId
          }/${document._key}.${document.type}`
        );

      await fileRef.delete();

      return true;
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return false;
    }
  }

  async handleModalAccept() {
    try {
      if (await this.deleteFileFromStorage(this.documentToEdit)) {
        const responseDelete = await this.documentService.deleteFailedDocument(
          this.documentToEdit._key as string
        );

        if (responseDelete.code === Http.Ok) {
          this.confirmDeletDialog = false;
          this.showEditDocumentModal = false;
          Snackbar.popSuccess(responseDelete.message);
          this.searchData(this.dataFilter);
          return;
        }

        Snackbar.popError(responseDelete.message);
        return;
      }

      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + DASHBOARD_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  handleModalCancel() {
    this.confirmDeletDialog = false;
  }
}
